<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="saveCurrentImage()">
        <app-dynamic-icon name="fa-solid fa-download" slot="icon-only"></app-dynamic-icon>
      </ion-button>
      <ion-button (click)="dismiss()">
        <app-dynamic-icon name="close" slot="icon-only"></app-dynamic-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <swiper-container
    #swiper
    init="false"
    class="full-swiper">
    @for(medium of media; track $index) {
      <swiper-slide>
        <div class="swiper-zoom-container">
          <img [src]="medium.fileId | httpImgSrc" [alt]="medium.originalname">
        </div>
      </swiper-slide>
    }
  </swiper-container>
</ion-content>
<div class="resize-handle" (mousedown)="startResize($event)"></div>
